import { render, staticRenderFns } from "./FilterCategory.vue?vue&type=template&id=18bcaa66&"
import script from "./FilterCategory.vue?vue&type=script&lang=ts&"
export * from "./FilterCategory.vue?vue&type=script&lang=ts&"
import style0 from "./FilterCategory.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports